import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AppWrapper from './AppWrapper';
import AdminPanel from './AdminPanel';
import AnalyticsTracker from './components/AnalyticsTracker';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AnalyticsTracker />
      <Routes>
        {/* Customer-facing site (default) */}
        <Route path="/*" element={<AppWrapper />} />

        {/* Super admin section */}
        <Route path="/super-admin/*" element={<AdminPanel />} />

        {/* Legacy admin alias */}
        <Route path="/admin/*" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
